const Constants = {
    BASEURLAPI : 'http://' + window.location.hostname + ':3001'
}

export default Constants;